export const CountryIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10224_152298)">
        <path
          d="M20.972 11.2905C20.8319 9.51854 20.1702 7.82775 19.0704 6.43136C17.9706 5.03497 16.4819 3.99551 14.7921 3.44406C13.1023 2.89262 11.2871 2.85389 9.57534 3.33277C7.86357 3.81164 6.33192 4.78666 5.17357 6.13487C4.01521 7.48309 3.28201 9.14412 3.06644 10.9085C2.85087 12.6729 3.16257 14.4616 3.96225 16.049C4.76192 17.6365 6.01375 18.9516 7.55987 19.8285C9.10598 20.7054 10.8771 21.1049 12.65 20.9765"
          stroke="#99A0AE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M3.60156 9H20.4016H3.60156Z" fill="white" />
        <path d="M3.60156 9H20.4016" stroke="#99A0AE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.60156 15H12.5016H3.60156Z" fill="white" />
        <path d="M3.60156 15H12.5016" stroke="#99A0AE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M11.4997 3C9.81501 5.69961 8.92188 8.81787 8.92188 12C8.92188 15.1821 9.81501 18.3004 11.4997 21"
          stroke="#99A0AE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M12.5 3C14.1887 5.70447 15.0821 8.82962 15.078 12.018L12.5 3Z" fill="white" />
        <path
          d="M12.5 3C14.1887 5.70447 15.0821 8.82962 15.078 12.018"
          stroke="#99A0AE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.121 20.1216C21.5406 19.7021 21.8265 19.1676 21.9423 18.5856C22.0581 18.0036 21.9988 17.4004 21.7717 16.8522C21.5447 16.3039 21.1602 15.8353 20.6668 15.5057C20.1734 15.176 19.5934 15 19 15C18.4066 15 17.8266 15.176 17.3332 15.5057C16.8398 15.8353 16.4553 16.3039 16.2283 16.8522C16.0012 17.4004 15.9419 18.0036 16.0577 18.5856C16.1735 19.1676 16.4594 19.7021 16.879 20.1216C17.297 20.5406 18.004 21.1666 19 22.0006C20.051 21.1106 20.759 20.4846 21.121 20.1216Z"
          stroke="#99A0AE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M19 18V18.01" stroke="#99A0AE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_10224_152298">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
